

























































































































































import { Component } from 'vue-property-decorator';
import CSelectButtonsApi from '@/components/Helper/Form/CSelectButtonsApi.vue';
import CPointSelect from '@/components/Helper/Form/CPointSelect.vue';
import PriceIcon from '@/components/Helper/Icon/Svg/PriceIcon.vue';
import { mapGetters } from 'vuex';
import ThanksBtnMixin from './thanks-btn.mixin';

@Component<ThanksBtnPc>({
  components: { PriceIcon, CPointSelect, CSelectButtonsApi },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  }
})
export default class ThanksBtnPc extends ThanksBtnMixin {
  get nameCategory() {
    let name = '';
    switch (this.$i18n.locale) {
      case 'ja':
        name = 'nameJa';
        break;
      case 'en':
        name = 'nameEn';
        break;
      case 'vi':
        name = 'nameVi';
        break;
      default:
        break;
    }
    return name;
  }

  /**
   * Action show dialog send gift
   */
  showThanksBtn() {
    this.dialog = true
  }
}
